module.exports = __webpack_public_path__ + "static/media/delete-icon-white.186e9137.svg";